var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.0001 5.4H4.2001V6.6H3.0001V5.4ZM11.4001 2.4V10.8C11.4001 11.46 10.8601 12 10.2001 12H1.8001C1.48184 12 1.17661 11.8736 0.951569 11.6485C0.726526 11.4235 0.600098 11.1183 0.600098 10.8L0.606098 2.4C0.606098 1.74 1.1341 1.2 1.8001 1.2H2.4001V0H3.6001V1.2H8.4001V0H9.6001V1.2H10.2001C10.8601 1.2 11.4001 1.74 11.4001 2.4ZM1.8001 3.6H10.2001V2.4H1.8001V3.6ZM10.2001 10.8V4.8H1.8001V10.8H10.2001ZM7.8001 6.6H9.0001V5.4H7.8001V6.6ZM5.4001 6.6H6.6001V5.4H5.4001V6.6Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.53c2145ae445519237058758c7575bd3.svg";
export { ForwardRef as ReactComponent };